





















import { Component, Prop, Vue } from 'vue-property-decorator';

import tippy from 'tippy.js';
import {IconList} from "@/types/core";

@Component
export default class SectionHeader extends Vue {
  
  @Prop({ default: '',  type: String}) title!: string;
  @Prop({ default: () => [],  type: Array}) iconList!: IconList[];

  mounted() {
    tippy('[data-tippy-content]', {
      distance: 5
    });
  }
  
  clickHandler(eventName:string) {
    this.$emit(eventName);
  }
  
}

